export default "__VITE_ASSET__UNMdDgRZ__"